<template>
  <el-header class="db-header" height="initial">
    <div class="level1">
      <div class="left-container">
        <MobileSidebar></MobileSidebar>
        <router-link to="/" class="logo-link">
          <div class="logo hidden-sm-and-down">
            <img :src="logo" alt="logo"/>
          </div>
          <h1 :title="title">
            {{ title }}
          </h1>
        </router-link>
      </div>
      <div class="right-container hidden-sm-and-down">
        <nav v-if="$route.path !== '/'">
          <Menus></Menus>
        </nav>
        <el-dropdown trigger="click" @command="handleSelectProject">
          <div class="el-dropdown-link">
            <span class="welcome-title">{{ slogan }} {{ version }}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <template v-if="projects.length">
              <el-dropdown-item
                v-for="project in projects"
                :key="project.id"
                :index="`${project.id}`"
                :command="project.id">
                <div :class="{ active: project.id === currentProject.id }">
                  {{ project.name }}
                </div>
              </el-dropdown-item>
            </template>
            <template v-else>
              <el-dropdown-item disabled>
                没有关联项目
              </el-dropdown-item>
            </template>
            <template v-if="currentAdminIsSuper">
              <el-dropdown-item index="projects" divided>
                <router-link :to="{ name: 'projects' }">
                  项目管理</router-link>
              </el-dropdown-item>
              <el-dropdown-item index="devicetest">
                <router-link :to="{ name: 'devicetest' }">
                  设备测试</router-link>
              </el-dropdown-item>
              <el-dropdown-item index="branches">
                <router-link :to="{ name: 'groupSetting' }">
                  分组设置</router-link>
              </el-dropdown-item>
              <el-dropdown-item index="warning-management">
                <router-link :to="{ name: 'warning-management' }">
                  险情处理</router-link>
              </el-dropdown-item>
              <el-dropdown-item index="settings">
                <router-link :to="{ name: 'settings' }">
                  系统设置</router-link>
              </el-dropdown-item>
              <el-dropdown-item index="admins">
                <router-link :to="{ name: 'admins' }">
                  账号管理</router-link>
              </el-dropdown-item>
              <el-dropdown-item index="lab" v-if="currentAdminIsSystem">
                <router-link :to="{ name: 'lab' }">
                  数据实验室</router-link>
              </el-dropdown-item>
            </template>
            <template v-else-if="currentAdminCanEdit">
              <el-dropdown-item index="projects" divided>
                <router-link :to="{ name: 'projects' }">
                  项目管理</router-link>
              </el-dropdown-item>
              <el-dropdown-item index="devicetest">
                <router-link :to="{ name: 'devicetest' }">
                  设备测试</router-link>
              </el-dropdown-item>
              <el-dropdown-item index="inner-settings">
                <router-link :to="{ name: 'inner-settings' }">
                  生产设置</router-link>
              </el-dropdown-item>
            </template>
            <el-dropdown-item index="logout" @click.native="logout" divided>
              注销账号 {{ currentAdminUsername }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="level2 hidden-sm-and-down" v-if="showLevel2">
      <nav>
        <Submenus></Submenus>
      </nav>
    </div>
  </el-header>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import MobileSidebar from '@/components/MobileSidebar';
import Menus from '@/components/menus/Menus';
import Submenus from '@/components/menus/Submenus';

export default {
  inject: ['reload'],
  components: {
    MobileSidebar,
    Menus,
    Submenus,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState('admin', ['currentAdmin']),
    ...mapState('project', ['projects', 'currentProject']),
    ...mapState('device', ['devices']),
    ...mapGetters('admin', [
      'currentAdminUsername', 'currentAdminIsSuper', 'currentAdminIsSystem',
      'currentAdminCanEdit',
    ]),
    ...mapState('menu', ['activeMenu']),
    ...mapGetters('meta', ['corpName', 'version', 'logo', 'slogan']),
    title() {
      if (this.$route.name === 'index') {
        return this.corpName;
      }
      return (this.currentProject && this.currentProject.name);
    },
    showLevel2() { // 判断是否需要显示二级菜单
      return this.$route.path !== '/'
        && this.activeMenu && this.activeMenu.submenus;
    },
  },
  methods: {
    handleSelectProject(index) {
      const selectId = Number.parseInt(index, 10);
      if (selectId) {
        const project = this.projects.find(p => p.id === selectId);
        this.$store
          .dispatch('project/changeProject', { project })
          .then(() => {
            // 只在header菜单栏切换项目刷新页面
            this.$router.push({ name: 'home' });
            this.reload();
            // this.$bus.$emit('changeProject');
          })
          .catch((err) => {
            this.$message.error(err.message);
          });
      }
    },
    logout() {
      this.$confirm('确定要注销吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info',
      }).then(() => {
        window.location = '/session/logout';
      }).catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/variables';

.db-header {
  position: relative;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
  z-index: 1001; // loading: 1000 dialog: 2002
  padding: 0;

  .level1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: white;

    .left-container {
      display: flex;
      height: $header-height;
      max-width: 100vw;
      overflow: hidden;
      .logo-link {
        display: flex;
        align-items: center;
        .logo {
          height: $header-height;
          display: inline-block;
          margin-left: 20px;
          img {
            box-sizing: border-box;
            padding: 5px;
            height: 100%;
          }
        }
        h1 {
          display: inline-block;
          margin: 0;
          padding: 0 5px;
          max-width: 350px;
          font-size: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .right-container {
      display: flex;
      align-items: center;
      margin-right: 20px;
    }
  }

  .level2 {
    border: 1px solid $border-color;
    border-bottom: none;
  }
}

.el-dropdown-menu__item {
  a {
    display: block;
  }
  // 高亮当前项目
  .active {
    color: $blue;
    font-weight: bold;
  }
}

.el-dropdown-menu {
  max-height: 500px;
  overflow: scroll;
}
</style>
